import React, { useContext } from 'react'
import { UserInfo } from '@Entities/user/user'
import UserRowComponent from '@Components/UserRowComponent'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import { Maybe } from '@Types'
import { SelectOption } from '@Components/Selectors/Select'

interface UserPermissionsUsersTableProps {
    eventGetUsers: (value?: Maybe<SelectOption>) => void
}

const UserPermissionsUsersTable = (props: UserPermissionsUsersTableProps) => {
    const { rightsholderUserStore } = useContext<RootStore>(StoresContext)
    const { eventGetUsers } = props

    const rightsholderUsers = rightsholderUserStore.rightsholderUsers

    return (
        <div className="users-block">
            {rightsholderUsers?.content.map((userData: UserInfo) => (
                <UserRowComponent key={userData.exposedId} userData={userData} onReloadData={() => eventGetUsers()} />
            ))}
            {rightsholderUsers && rightsholderUsers.totalElements < 1 && <p className="small no-results">No results</p>}
        </div>
    )
}

export default observer(UserPermissionsUsersTable)
